import { Expression } from './Expression.js';
export class VariableDeclarationExpression extends Expression {
    constructor(variableName, optionalDataType, oclExpressionAsValue) {
        super();
        this.variableName = variableName;
        this.optionalDataType = optionalDataType;
        this.oclExpressionAsValue = oclExpressionAsValue;
    }
    getVariableName() {
        return this.variableName;
    }
    evaluate(visitor, localVariables) {
        return this.oclExpressionAsValue.evaluate(visitor, localVariables);
    }
}
//# sourceMappingURL=VariableDeclarationExpression.js.map